<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('event.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('event.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('event.detail.livestream.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <event-live-streaming-info :event="event"></event-live-streaming-info>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-button :to="{ name: 'events' }" variant="primary" block>{{ $t('event.detail.button.view-more.label') }}</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'

import EventLiveStreamingInfo from '@/components/info/EventLiveStreamingInfo'

import i18n from '@/plugins/i18n.js'

import EventApiService from '@/services/budaedu-api-services/event-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)

Vue.use(EventApiService)

export default {
  i18n,
  name: 'event-live-streaming',
  props: {
    id: {
      type: Number,
      require: true
    }
  },
  data() {
    return {
      event: null
    }
  },
  methods: {
    async setEvent() {
      const item = await this.$eventApiService.getById(this.id)
      this.event = item.data
    }
  },
  async created() {
    //alert(`Vue version : ${Vue.version}`);
    await this.setEvent()
  },
  components: {
    EventLiveStreamingInfo
  },
  metaInfo() {
    const title = this.$t('event.detail.livestream.title')
    const sub_title = this.event ? `-${this.event.name}` : ''
    return {
      title: `${title}${sub_title}`,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>